module.exports = __webpack_public_path__ + "fonts/65c7b0c96d644be47ca4a652b2d47972-Roboto-BoldItalic.woff";